// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Star: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 57.8"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M47.3 56.9c-.2 0-.4-.1-.6-.2L30 48l-16.7 8.8c-.5.2-1 .2-1.4-.1-.4-.3-.6-.8-.5-1.3l3.2-18.6L1 23.6c-.4-.4-.5-.9-.3-1.4.2-.5.6-.9 1.1-.9l18.6-2.7 8.3-16.9c.3-.5.8-.8 1.3-.8s1 .3 1.2.8l8.3 16.9 18.6 2.7c.5.1.9.4 1.1.9.2.5 0 1-.3 1.4L45.5 36.7l3.2 18.6c.1.5-.1 1-.5 1.3-.3.2-.6.3-.9.3zM30 45c.2 0 .4.1.6.2L45.5 53l-2.8-16.5c-.1-.4.1-.9.4-1.2l12-11.7-16.6-2.4c-.4-.1-.8-.3-1-.8L30 5.4l-7.4 15c-.2.4-.6.7-1 .8L5 23.6l12 11.7c.3.3.5.8.4 1.2L14.5 53l14.8-7.8c.3-.1.5-.2.7-.2z"/></svg>;
};

export default React.memo(Star);
